<template>
  <div>
    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '60px' }">
      <dataWrap></dataWrap>
      <!-- <div class="dataWrapBox" id="dataWarp" @scroll.prevent>
        <div class="dataWrap" id="ulDiv" @scroll.prevent>
          <ul class="ul-scroll" @scroll.prevent style="margin-left: -36px">
            <li @scroll.prevent v-for="item in dataList" :key="item.id" style="height: 30px">
              <span
                class="title"
                @click="Rowclicklu"
                v-if="item.alarmLevel == '报警'"
                style="color: #ff0000; margin-left: 5px; margin-right: 5px"
              >
                <img src="./Call-the-police.png" alt="" style="width: 20px; height: 20px" />
                <a-tooltip>
                  <template slot="title">{{ item.title }}</template>
                  {{ item.title }}
                </a-tooltip>
              </span>
              <span
                class="title"
                @click="Rowclicklu"
                v-if="item.alarmLevel !== '报警'"
                style="color: #ffcc66; margin-left: 5px; margin-right: 5px"
              >
                <img src="./warning.png" alt="" style="width: 20px; height: 20px" />
                <a-tooltip>
                  <template slot="title">{{ item.title }}</template>
                  {{ item.title }}
                </a-tooltip>
              </span>
            </li>
          </ul>
        </div>
        <div id="ulDiv2"></div>
      </div> -->
    </a-card>
    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '248px', 'margin-top': '14px' }">
      <div slot="title">
        <div class="radius"></div>
        <div class="radiusTitle">远传水表概览统计</div>
      </div>
      <div slot="extra" class="extra">个</div>
      <div class="content">
        <NestedRing :total="total" :data="OverviewList" />
      </div>
    </a-card>

    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '248px', 'margin-top': '24px' }">
      <div slot="title">
        <div class="radius"></div>
        <div class="radiusTitle">远传水表用户类型占比</div>
      </div>
      <div slot="extra" class="extra">个</div>
      <div class="content" id="conte2">
        <RingDiagram key="date2" :data="ProportionUserList"></RingDiagram>
      </div>
    </a-card>
  </div>
</template>

<script>
import iconRight from '@/assets/myImg/1/icon-right-circle.svg?inline'
import RingDiagram from '@/components/Charts/RingDiagram'
import NestedRing from './module/NestedRing.vue'
import dataWrap from './module/dataWrap.vue'
import { getUUID } from '../../../../utils/util'
export default {
  name: 'RemoteZoneLeft',
  components: {
    iconRight,
    RingDiagram,
    NestedRing,
    dataWrap,
  },
  data() {
    return {
      ProportionId: getUUID(),
      ProportionUserId: getUUID(),
      loading: false,
      total: 0,
      ProportionList: [],
      ProportionUserList: [],
      OverviewList: [],
      selectData: '计量电池更换期限',
      listData: [],
      map: null,
      openQueryTable: false,
      diameter: null,
      material: null,
      dataList: [],
      speed: 80,
      colee: '',
      colee1: '',
      colee2: '',
      dataWarp: '',
    }
  },
  created() {
  },
  methods: {
    getList() {
      //远传水表占比
      this.$http.get('/pipe-network/remote_transmission_workbenchs/find/workbench').then((res) => {
        console.log(res.data, '123123123')
        let datas = res.data

        if (datas.overviewList.length != null) {
          let list = []
          this.total = datas.sumWaterOnLine
          for (let i = 0; i < datas.overviewList.length; i++) {
            list.push({
              name: datas.overviewList[i].name,
              value: datas.overviewList[i].num,
              percentage: datas.overviewList[i].percentage,
            })
          }
          this.OverviewList = list
          console.log(list)
        }

        if (datas.typeList.length != null) {
          let lists = []
          for (let i = 0; i < datas.typeList.length; i++) {
            lists.push({
              name: datas.typeList[i].name,
              value: datas.typeList[i].num,
              percentage: datas.typeList[i].percentage,
            })
          }
          this.ProportionUserList = lists
        }
      })

      //远传水表概览统计
      //   this.$http.get('/pipe-network/yc_user_remote_water_meters/overview/proportion').then(res => {
      //     var list = []
      //     let datas = res.data
      //   })
      // },
      // getProportionUserList() {
      //   //统计用户类型占比
      //   setTimeout(() => {
      //     this.$http.get('/pipe-network/yc_user_remote_water_meters/type/proportion').then(res => {
      //       let list = []
      //       let datas = res.data

      //     })
      //   }, 1000)
      // }
    },
  },
  mounted() {
    this.getList()
    // this.getProportionUserList()
  },
}
</script>
<style lang="less" scoped>
.radius {
  float: left;
  width: 6px;
  height: 21px;
  background: #0265ff;
  border-radius: 3px;
}
.radiusTitle {
  margin-left: 10px;
  float: left;
  width: 100px;
  height: 21px;
  line-height: 21px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}

.radioTitle {
  height: 29px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.56px;
  font-weight: 600;
}
.extra {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #a7afb5;
  letter-spacing: 0.48px;
  text-align: right;
  font-weight: 400;
}
.cardHead {
  height: 48px;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 2px;
  border-bottom: 1px solid #e8e8e8;
  .radiusTitleStatis {
    float: left;
    // width: 100px;
    // height: 21px;
    line-height: 21px;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 15px;
    color: #101010;
    letter-spacing: 0.63px;
    font-weight: 600;
  }
  .extra {
    width: 40%;
    min-width: 120px;
  }
}
/deep/ .ant-card-body {
  padding: 0;
}
.dataWrapBox {
  height: 58px;
  width: 284px;
  overflow-x: hidden;
  border-radius: 10px;
  // background: rgba(127, 156, 193, 0.5);
  .dataWrap {
    .tableItem {
      height: 40px;
      flex-direction: row;
      justify-content: space-around;
      .tableItemDiv {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        color: #1a1919;
        span {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      span {
        display: inline-block;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        color: #0e0d0d;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
.title {
  display: block;
  overflow: hidden; /*内容超出后隐藏*/
  text-overflow: ellipsis; /* 超出内容显示为省略号 */
  white-space: nowrap; /* 文本不进行换行 */
  width: 260px;
}
// .title:hover {
//   text-overflow: inherit;
//   overflow: visible;
//   white-space: pre-line;
// }
.dataWrapBox::-webkit-scrollbar {
  width: 0 !important;
}
.dataWrapBox::-webkit-scrollbar {
  -ms-overflow-style: none;
}
.dataWrapBox::-webkit-scrollbar {
  overflow: -moz-scrollbars-none;
}
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  .main {
    height: 100%;
    flex: 1;
  }

  .ul-scroll {
    margin-left: -36px;
    li {
      width: 500px;
      padding: 5px;
      span {
        margin-left: 5px;
        margin-right: 5px;
      }
    }
  }
}
</style>
